export const ContractObjectDefaults = {
  Contract: {}, //No longer created in State by Sure MGA. No Sure MGA Defaults.
  Consumer: {}, //No longer created in State by Sure MGA. No Sure MGA Defaults.
  Address: {
    Dflt_Address_Ind: 'N'
  },
  Phone: {
    Dflt_Phone_Ind: 'N'
  },
  Contract_Location: {
    In_City_Limits_Ind: 'N',
    State_Wide_Ind: 'N'
  },
  Sub_Location: {},
  Contract_Name: {},
  Contract_Condition: {
    Selected_Ind: 'Y',
    Adhoc_Ind: 'N'
  },
  Contract_Form: {
    Selected_Ind: 'Y',
    Doc_Package_Type: 'Contract'
  },
  Contract_Factor: {},
  Contract_Interest: {
    Payor_Ind: 'N',
    Contract_Print_Ind: 'N',
    Cert_Ind: 'N',
    Info_Bill_Ind: 'N'
  },
  Interest_Name: {
    Entity_ID: '',
    Entity_Name: '',
    Edit_Status: 'N',
    Prospect_Ind: 'N',
    Preferred_Ind: 'N'
  },
  Contract_Broker: {
    Broker: {
      Entity_ID: '',
      Entity_Name: ''
    },
    Participation_Pct: '100',
    Principal_Ind: 'Y',
    Net_Broker_Ind: 'Y',
    Flat_Amount_Ind: 'N',
    Manual_Comm_Ind: 'N'
  },
  Contract_Supplier: {
    Source_Supplier: {
      Entity_ID: '',
      Entity_Name: ''
    },
    RiskGroup_Share_Pct: '100',
    Principal_Ind: 'Y',
    Flat_Amount_Ind: 'N',
    Manual_Comm_Ind: 'N'
  },
  Contract_Producer: {
    Producer: {
      Entity_ID: ''
    },
    Participation_Pct: '100',
    Principal_Ind: 'Y',
    Flat_Amount_Ind: 'N',
    Manual_Comm_Ind: 'N'
  },
  Contract_FinanceCo: {
    FinCo: {
      Entity_ID: ''
    }
  },
  Team_Member: {
    Principal_Ind: 'N',
    Primary_Ind: 'N'
  },
  Contract_Attachment: {
    Send_With_Contract_Ind: 'N'
  },
  Contract_Profile: {
    Country: 'USA',
    MVR_Clean_Record_Ind: 'N',
    MVR_Report_Found_Ind: 'N'
  },
  CDAA_Vehicle: {
    ACV_Ind: 'N',
    Stated_Amount_Ind: 'N',
    New_Car_Ind: '?',
    Vehicle_Altered_Ind: '?',
    Leased_Ind: '?',
    Non_Owned_Ind: '?',
    Seen_Car_Ind: '?',
    Bumper_Discount_Ind: '?',
    Carpool_Ind: '?',
    Unrepaired_Damage_Ind: '?',
    Residual_Market_Ind: '?',
    Fleet_Ind: '?',
    Motor_Carrier_Act_Ind: '?',
    Farm_Ranch_Ind: '?',
    Self_Propelled_Ind: '?',
    Traction_Ind: '?',
    Running_Lights_Ind: '?',
    Anti_Theft_Device_Ind: '?',
    Registered_Ind: '?',
    Ever_Registered_Ind: '?',
    VIN_Etching_Ind: '?',
    Hidden_Transmitter_Ind: '?',
    Usage_Car_Shows_Ind: '?',
    Usage_Visitors_Ind: '?',
    Usage_Maintenance_Ind: '?',
    Usage_Racing_Ind: '?',
    Usage_Drivers_Ed_Events_Ind: '?',
    Usage_General_Transport_Ind: '?',
    Usage_Errands_Ind: '?',
    Usage_Work_Ind: '?',
    Usage_Vacation_Ind: '?',
    Usage_Restaurants_Ind: '?',
    Usage_Recreational_Ind: '?',
    Usage_Off_Road_Ind: '?',
    Usage_Other_Ind: '?'
  },
  CDAA_Driver: {
    Excluded_Ind: '?',
    Resident_Custody_Ind: '?',
    Driver_Training_Ind: '?',
    Good_Student_Ind: '?',
    Distant_Student_Ind: '?',
    Impaired_Ind: '?',
    Defensive_Driver_Ind: '?',
    Mature_Driver_Ind: '?',
    License_Restricted_Ind: '?',
    Assigned_Risk_Ind: '?',
    Lic_Suspend_Ind: '?',
    Excl_Youthful_Drvr_Ind: '?',
    Excl_Furnished_Drvr_Ind: '?'
  },
  CDAA_Driver_Vehicle: {
    Principal_Driver_Ind: '?',
    Excluded_Driver_Ind: '?',
    Governing_Driver_Ind: '?'
  },
  CDAA_Driver_Violation: {
    BI_Ind: 'N',
    Death_Ind: 'N',
    At_Fault_Ind: 'N',
    Accident_Ind: 'N',
    Suspended_Ind: 'N',
    Injury_Ind: 'N'
  },
  CDAA_Driver_Discount: {},
  CDAA_Driver_FinResp: {},
  CDAC_Auto_Symbol: {},
  CDAC_Filing: {},
  CDAC_Filing_Detail: {},
  CDAC_State_Rating: {
    HB_Minimum_Ind: '?',
    Indv_Emp_Liability_Ind: '?',
    Social_Service_Ind: '?',
    DOC_FinResp_Cert_Ind: '?'
  },
  CDAC_Truck_Equipment: {},
  CDAC_Truck_Interchange: {},
  CDAC_Truck_Terminal: {},
  CDAC_Truck_Zone: {},
  CDAC_Underwriting: {
    Veh_Maint_Ind: '?',
    Radius_Exceed_Ind: '?',
    MVR_Verify_Ind: '?',
    Driver_Recruit_Ind: '?',
    Driver_Train_Ind: '?',
    Driver_Test_Ind: '?',
    Target_Commodities_Ind: '?',
    Driver_Physicals_Ind: '?',
    Hire_Equipment_Ind: '?',
    Lease_To_Others_Ind: '?',
    Lease_With_Oper_Ind: '?',
    Insuring_Agree_Ind: '?',
    Haul_For_Others_Ind: '?',
    Others_Permit_Ind: '?',
    Canada_Cov_Ind: '?',
    Mexico_Cov_Ind: '?',
    Per_Trip_Comp_Ind: '?',
    Gross_Receipts_Ind: '?',
    Work_Comp_Ind: '?',
    USA_Cov_Ind: '?',
    Hold_Harmless_Ind: '?',
    Not_Soley_Owned_Ind: '?',
    Employee_Own_Auto_Ind: '?',
    Haz_Materials_Ind: '?',
    Filings_Reqd_Ind: '?',
    Used_By_Family_Ind: '?',
    Not_Sched_Ind: '?',
    MVR_Reqd_Ind: '?',
    Equip_Not_Listed_Ind: '?',
    Agent_Inspected_Indicator: '?',
    Moving_Violations_Indicator: '?',
    Belong_To_Others_Pct: '100'
  },
  CDAM_Animal: {},
  CDAP_Underwriting: {
    Auto_Club_Ind: '?',
    Cars_At_School_Ind: '?',
    Parked_On_Street_Ind: '?'
  },
  CDDO_Rating: {
    Single_Shareholder_Over_5Pct_Ind: '?',
    Pvt_Placement_Complete_Ind: '?',
    HR_Dept_Ind: '?',
    HR_Manual_Ind: '?',
    Employee_Handbook_Ind: '?'
  },
  CDEO_Rating: {},
  CDEO_Job: {},
  CDEO_Underwriting: {},
  CDGD_PhysDam_Loc: {
    Scheduled_Ind: '?'
  },
  CDGD_Underwriting: {
    Repair_Shop_Ind: '?',
    MH_Trailer_Shop_Ind: '?',
    Service_Station_Ind: '?',
    Comm_Trailer_Dealer_Ind: '?',
    Storage_Garage_Ind: '?',
    Public_Parking_Ind: '?',
    Franchise_Ind: '?'
  },
  CDGL_Class_Rating: {
    Installs_Services_Ind: '?',
    Foreign_Product_Ind: '?',
    New_Product_Plan_Ind: '?',
    Guarantee_Ind: '?',
    Aircraft_Space_Ind: '?',
    Recall_Discontinue_Ind: '?',
    Product_of_Others_Ind: '?',
    Label_of_Others_Ind: '?',
    Vendors_Cov_Ind: '?',
    Sells_to_Insured_Ind: '?',
    Prem_Prod_Ind: '?',
    Plans_Specs_Ind: '?',
    Explosives_Ind: '?',
    Tunneling_Ind: '?',
    Contractors_Cov_Ind: '?',
    Certificates_Ind: '?',
    Lease_Equip_Ind: '?'
  },
  CDGL_Claims_Made: {},
  CDGL_Underwriting: {
    Medical_Doctors_Ind: '?',
    Radioactive_Ind: '?',
    HazMat_Ind: '?',
    Ops_Sold_Ind: '?',
    Machinery_Rented_Ind: '?',
    Watercraft_Ind: '?',
    Parking_Facilities_Ind: '?',
    Parking_Charges_Ind: '?',
    Recreation_Ind: '?',
    Swimming_Pool_Ind: '?',
    Sporting_Event_Ind: '?',
    Planned_Alteration_Ind: '?',
    Planned_Demolition_Ind: '?',
    Joint_Venture_Ind: '?',
    Lease_Employees_Ind: '?',
    Labor_Interchange_Ind: '?',
    Day_Care_Ind: '?'
  },
  CDGL_Class_Product: {
    Leased_Ind: '?',
    Imported_Ind: '?',
    Exported_Ind: '?',
    New_Product_Ind: '?',
    Aircraft_Space_Ind: '?',
    Vendors_Coverage_Ind: '?',
    Sells_To_NamedIns_Ind: '?'
  },
  CDGK_Rating: {},
  CDGK_Underwriting: {
    Lot_Fenced_Ind: '?',
    Lot_Lit_Ind: '?',
    Police_Protection_Ind: '?',
    Property_Guarded_Ind: '?',
    Premises_Unattended_Ind: '?',
    Self_Closing_Doors_Ind: '?',
    Burglar_Alarm_Ind: '?',
    Multi_Ramp_Ind: '?',
    Damage_Checked_Ind: '?',
    New_Vehicle_Ind: '?',
    Used_Vehicle_Ind: '?',
    Campers_Ind: '?',
    Tractors_Ind: '?',
    Trailers_Ind: '?',
    Semi_Trailers_Ind: '?',
    Trucks_Ind: '?',
    Mobile_Homes_Ind: '?',
    Snowmobiles_Ind: '?',
    Other_Vehicle_Ind: '?'
  },
  CDPL_Rating: {},
  CDPL_Underwriting: {},
  CDPO_Rating: {
    Airport_Authority_Ind: '?',
    Airport_Contract_Ind: '?',
    Airport_Flight_Pattern_Ind: '?',
    Electric_Authority_Ind: '?',
    Electric_EMF_Monitor_Ind: '?',
    Electric_Buried_Lines_Ind: '?',
    Electric_Own_Maint_Ind: '?',
    EPL_Controls_Ind: '?',
    Facultative_Approval_Ind: '?',
    Gas_Authority_Ind: '?',
    Gas_Buried_Lines_Ind: '?',
    Gas_EMF_Monitor_Ind: '?',
    Electric_Generation_Ind: '?',
    Gas_Generation_Ind: '?',
    Gas_Own_Maintain_Ind: '?',
    Housing_Authority_Ind: '?',
    Housing_Inspection_Ind: '?',
    Housing_Limit_Factor_Ind: '?',
    Housing_High_Rise_Ind: '?',
    Large_Population_Ind: '?',
    Metro_Exposure_Ind: '?',
    Port_Authority_Ind: '?',
    Positive_Financial_Pos_Ind: '?',
    Single_Large_Loss_Ind: '?',
    Special_Acceptance_Ind: '?',
    Transit_Authority_Ind: '?',
    Unusual_Exposures_Ind: '?',
    Zoning_Controls_Ind: '?'
  },
  CDMM_Facility: {},
  CDMM_Underwriting: {
    Claim_Trigger: 'D'
  },
  CDMM_Individual: {},
  CDPL_Individuals: {},
  CDMM_Individual_Schedule: {},
  CDPC_Underwriting: { 
    Sprinkler_Ind: '?',
    Wiring_Improve_Ind: '?',
    Roofing_Improve_Ind: '?',
    Plumbing_Improve_Ind: '?',
    Heating_Improve_Ind: '?',
    Other_Improve_Ind: '?'
  },
  CDPC_Underwriting_Location: {},
  CDPC_Underwriting_Protect: {
    Central_Station_Ind: '?',
    With_Keys_Ind: '?',
    Local_Gong_Ind: '?',
    Remote_Camera_Ind: '?',
    Maint_Contract_Ind: '?'
  },
  CDPC_Blanket_Rating: {},
  CDPC_Class_Rating: {
    Agreed_Value_Ind: ['?'],
    Seacoast_Ind: ['?'],
    Habitational_Ind: ['?'],
    Intercoastal_Ind: ['?'],
    Medical_Ind: ['?'],
    Sinkhole_Cov_Ind: ['?']
  },
  CDPC_Glass_Schedule: {},
  CDPC_Glass_Underwriting: {
    Fixed_Plates_Ind: '?',
    Unusual_Setting_Ind: '?',
    Insure_Tape_Ind: '?',
    Insure_Lettering_Ind: '?',
    Area_Construct_Ind: '?',
    Defects_Ind: '?',
    Agent_Inspection_Ind: '?',
    Vacant_Ind: '?',
    Off_Premises_Ind: '?',
    All_Above_2nd_Floor_Ind: '?',
    All_Exterior_Insured_Ind: '?',
    Structural_Glass_Ind: '?',
    Mesh_Glazing_Ind: '?'
  },
  CDUX_Care_Custody_Control: {
    Held_Harmless_Ind: '?',
    Waiver_of_Subrogation_Ind: '?',
    Named_Insured_Ind: '?',
    Other_Liab_Relationship_Ind: '?'
  },
  CDUX_Location: {},
  CDUX_Primary: {},
  CDUX_Underlying: {
    Prev_Cov_Excl_Ind: '?',
    Tail_Coverage_Ind: '?',
    Auto_Symbol_1_Ind: '?',
    Annual_Agg_Limit_Ind: '?',
    Per_Loc_Agg_Ind: '?',
    Defense_Costs_Incl_Ind: '?',
    Claims_Made_Form_Ind: '?'
  },
  CDUX_Vehicle: {},
  CDUX_Watercraft: {},
  CDIM_Accounts_Receivable: {
    Duplicate_Records_Ind: '?',
    Cycle_Billing_Ind: '?',
    Separate_Billed_Unbilled_Ind: '?'
  },
  CDIM_Builders_Risk: {
    Construction_Started_Ind: '?',
    Safeguards_Used_Ind: '?',
    Site_Lighting_Ind: '?',
    Perimeter_Fence_Ind: '?',
    Rigging_Tandem_Lift_Ind: '?'
  },
  CDIM_Builders_Risk_Underwriting: {
    Demolition_Wrecking_Ind: '?',
    Subcontractors_Uninsured_Ind: '?',
    OffPrem_Sign_Ind: '?',
    Property_Not_Covered_Ind: '?',
    Applicant_Product_Ind: '?',
    Boiler_Work_Ind: '?',
    Direct_Oversite_Ind: '?',
    Dust_Collection_System_Ind: '?',
    Spray_Booth_Safe_Ind: '?',
    Roofing_Ind: '?',
    Shop_Work_Ind: '?',
    Renovation_Work_Ind: '?',
    Interior_Wall_Gutting_Ind: '?',
    Underground_Cable_Work_Ind: '?',
    Street_Road_Work_Ind: '?',
    Excavations_Marked_Ind: '?',
    Utilities_Staked_Ind: '?',
    Staking_Inquiries_Logged_Ind: '?',
    Shoring_Work_Safe_Ind: '?',
    Removal_Work_Ind: '?',
    Asbestos_Removal_Work_Ind: '?',
    Performed_EIFS_Related_Work_Ind: '?',
    Managed_EIFS_Related_Work_Ind: '?',
    EIFS_Losses_Ind: '?',
    Excavation_Work_Ind: '?',
    Pesticide_Fertilizer_Spray_Ind: '?',
    Tree_Trimming_Work_Ind: '?',
    Off_Season_Work_Ind: '?',
    Snowplowing_Ind: '?',
    Retaining_Walls_Ind: '?',
    Mix_In_Transit_Ind: '?',
    Basement_Work_Ind: '?',
    Above_2Story_Work_Ind: '?',
    Scaffolding_Ind: '?',
    Painting_Water_Gas_Ind: '?',
    Painting_Bridges_Towers_Ind: '?',
    Exterior_Spray_Paint_Ind: '?',
    Airless_Spray_Gun_Ind: '?',
    Lead_Paint_Removal_Ind: '?',
    Flammables_Chemicals_Install_Ind: '?',
    Refrigeration_Install_Ind: '?',
    Mechanical_Operation_Ind: '?',
    Written_Procedures_Sweatingpipes_Ind: '?',
    Septic_Install_Ind: '?',
    Hot_Tar_Ind: '?',
    Tar_Heated_Ind: '?',
    Written_Procedures_RoofOpenings_Ind: '?',
    Operating_Equipment_Not_Included_Ind: '?',
    Sprinklers_Ind: '?'
  },
  CDIM_Communications: {
    Falling_Tower_Range_Ind: '?'
  },
  CDIM_Communications_TowerAntenna: {
    DeIcing_Equipment_Ind: '?',
    Tower_On_Bldg_Ind: '?'
  },
  CDIM_EDP: {
    Leased_Ind: '?'
  },
  CDIM_EDP_Underwriting: {
    Operational_1Week_After_Catastrophe_Ind: '?',
    Other_Equip_Arrangement_Ind: '?',
    Prompt_Equip_Replacement_Ind: '?',
    Manufacturer_Warranty_Ind: '?',
    Service_Maintenance_Ind: '?',
    Common_Carrier_Ship_Equip_Ind: '?',
    Company_Vehicle_Ship_Equip_Ind: '?',
    Common_Carrier_Ship_Media_Ind: '?',
    Company_Vehicle_Ship_Media_Ind: '?',
    Burglar_Alarm_Ind: '?',
    Uninterruptible_Power_Source_Ind: '?',
    Line_Conditioner_Ind: '?',
    Pwr_Suppressor_Volt_Regulator_Ind: '?',
    Dedicated_Line_Ind: '?',
    Equip_In_Designated_Room_Ind: '?',
    Access_Restricted_Ind: '?',
    Shutdown_Switch_Ind: '?',
    Separate_AC_System_Ind: '?',
    Wet_Sprinkler_Ind: '?',
    Dry_Sprinkler_Ind: '?',
    CO2_Ind: '?',
    Other_Ind: '?',
    Pedestal_Floor_Ind: '?',
    Floor_Combustible_Ind: '?',
    Below_Floor_Protection_Ind: '?',
    Below_Floor_Smoke_Detector_Ind: '?',
    Below_Floor_CO2_Ind: '?',
    Below_Floor_Other_Ind: '?',
    Anti_Viral_Safeguards_Ind: '?',
    Software_Duplicates_Ind: '?',
    Duplicate_Software_OnPrem_Ind: '?',
    Data_Backup_OnPrem_Ind: '?'
  },
  CDIM_Equipment_Floater: {
    Rent_Equipment_Ind: '?',
    Underground_Ind: '?',
    Afloat_Ind: '?',
    Blasting_Explosive_Ind: '?',
    Contractor_Coverage_Less_Ind: '?'
  },
  CDIM_Schedule_Summary: {
    Leased_Ind: '?',
    Min_Prem_Ind: '?',
    Blanket_Ind: '?',
    Exhibited_Ind: '?',
    In_Vault_Ind: '?',
    Prof_Comm_Use_Ind: '?',
    Custom_Use_Ind: '?'
  },
  CDIM_Schedule_Items: {
    Leased_Ind: '?',
    Purchased_New_Ind: '?',
    Photo_Ind: '?',
    Appraisal_Ind: '?',
    Min_Prem_Ind: '?'
  },
  CDIM_Subcontractor_Underwriting: {},
  CDIM_Transportation: {
    Open_Reporting_Ind: '?',
    Consolidated_Ind: '?',
    FOB_Contingent_Cov_Ind: '?'
  },
  CDIM_Transportation_Detail: {
    Full_Value_Ind: '?'
  },
  CDIM_Transportation_Rigging: {
    Rigging_Tandem_Lift_Ind: '?'
  },
  CDIM_Builders_Risk_Rigging_Item: {
    Hoist_Ind: '?',
    Leased_Ind: '?',
    Purchased_New_Ind: '?'
  },
  CDCR_Rating: {
    Inventory_Included_Ind: '?',
    Bank_Reconciliation_Ind: '?',
    Counter_Signature_Ind: '?',
    Joint_Control_Ind: '?',
    Vacation_Ind: '?',
    Locations_Audited_Ind: '?',
    Audit_Standards_Ind: '?',
    Audit_Discrepancies_Ind: '?',
    Internal_Audit_Ind: '?',
    Internal_Audit_Rendering_Ind: '?',
    Checks_Stamped_Ind: '?',
    Night_Deposit_Ind: '?',
    Operate_24Hr_Ind: '?',
    Private_Conveyance_Ind: '?',
    Safety_Satchel_Ind: '?',
    Line_Security_Ind: '?'
  },
  CDCR_Employees: {},
  CDCR_Money_Securities: {},
  CDCR_Safe_Vault_Info: {
    Outer_Comb_Lock_Ind: '?',
    Inner_Comb_Lock_Ind: '?',
    Chest_Comb_Lock_Ind: '?',
    Relocking_Device_Ind: '?',
    Time_Lock_Ind: '?'
  },
  CDJB_Rating_Exhibition: {},
  CDJB_Rating_Off_Premises: {},
  CDJB_Underwriting: {},
  CDJB_Underwriting_Protect: {
    Safe_On_Premises_Ind: '?',
    UL_Cert_Ind: '?',
    Central_Station_Ind: '?',
    Local_Alarm_Ind: '?',
    Police_Station_Connect_Ind: '?'
  },
  CDPP_Schedule: {
    Commercial_Use_Ind: '?',
    Exhibited_Ind: '?'
  },
  CDPP_Item: {},
  CDPX_Rating: {
    Policies_Procedures_Ind: '?',
    Training_Ind: '?',
    Jail_Controls_Ind: '?',
    Metro_Exposure_Ind: '?',
    Recent_Suicide_Attempts_Ind: '?',
    Selection_Controls_Ind: '?',
    Single_Large_Loss_Ind: '?',
    High_Loss_Ratio_Ind: '?',
    Manual_Rate_Ind: '?',
    Facultative_Approval_Ind: '?'
  },
  CDSB_Rating: {
    EPL_Controls_Ind: '?',
    Selection_Controls_Ind: '?',
    Policies_Procedures_Ind: '?',
    Good_Fiscal_Position_Ind: '?',
    High_Student_Teacher_Ratio_Ind: '?',
    Large_Premium_Ind: '?',
    Single_Large_Loss_Ind: '?'
  },
  CDWC_Class_Rating: {
    If_Any_Basis_Ind: '?',
    Governing_Class_Ind: '?'
  },
  CDWC_Individual: {},
  CDWC_Other_State: {},
  CDWC_State_Rating: {},
  CDWC_Underwriting: {
    Air_Water_Exp_Ind: '?',
    Under_Over_Ind: '?',
    Vessels_Dock_Ind: '?',
    Other_Bus_Ind: '?',
    Subcontractors_Ind: '?',
    Without_Certs_Ind: '?',
    Safety_Prog_Ind: '?',
    Group_Trans_Ind: '?',
    Emp_U16_O50_Ind: '?',
    Emp_O60_Ind: '?',
    Part_Time_Ind: '?',
    Volunteer_Ind: '?',
    Handicap_Ind: '?',
    Emp_Travel_Ind: '?',
    Athletics_Ind: '?',
    PreEmp_Physical_Ind: '?',
    Decl_Cancel_Ind: '?',
    Emp_Health_Ind: '?',
    Hazard_Mat_Ind: '?'
  },
  CDLL_Rating: {
    Cover_Charge_Ind: '?'
  },
  CDLL_Underwriting: {
    Ins_Declined_Ind: '?',
    Bankruptcy_Last_5Years_Ind: '?',
    Cited_Last_5Years_Ind: '?',
    Alcohol_Training_Ind: '?',
    Seasonal_Oper_Ind: '?',
    Bouncers_Used_Ind: '?',
    Dancing_Ind: '?',
    Sched_Entertainment_Ind: '?',
    Occ_Entertainment_Ind: '?'
  },
  CDMA_ERP: {
    ERP_Rate_At_Renew_Cancel_Ind: '?',
    Limit_Reinstate_Ind: '?',
    Reinstate_DED_SIR_Ind: '?'
  },
  Prior_History: {
    Transfer_Ind: '?',
    Detail_Loss_Ind: 'N',
    Prior_Premium: '0.00',
    Prior_Deductible: '0.00',
    Prior_Exposure_Base: '0.00',
    Prior_Exposure_Rate: '0.00',
    Prior_Limit: '0.00',
    Open_Claim_Count: '0',
    Closed_Claim_Count: '0',
    Tot_Avail_Reserve: '0.00',
    Tot_Avail_Exp_Reserve: '0.00',
    Tot_Pay_Made: '0.00',
    Tot_Exp_Pay_Made: '0.00',
    Tot_Incured: '0.00',
    Tot_Recovery: '0.00',
    Net_of_Recoveries: '0.00',
    Net_Loss_Ratio: '0.00',
    Dev_Loss_Ratio: '0.00'
  },
  Loss_Summary_Detail: {
    Catastrophe_Ind: 'N',
    Probable_Incurred: '0.00',
    Avail_Reserve: '0.00',
    Avail_Exp_Reserve: '0.00',
    Pay_Made: '0.00',
    Exp_Pay_Made: '0.00',
    Incurred: '0.00',
    Recovery: '0.00',
    Net_of_Recoveries: '0.00'
  },
  CDHM_Homeowners: {
    CDHM_Underwriting: {
      Protection_Class_Ind: '?',
      Thermo_Control_Ind: '?',
      Portable_Heat_Ind: '?',
      Business_Premises_Ind: '?',
      Hillside_Ind: '?',
      Under_Constr_Ind: '?',
      Diving_Board_Ind: '?',
      Farm_Use_Ind: '?',
      Protect_Device_Ind: '?',
      Day_Occupied_Ind: '?',
      Visible_Ind: '?',
      In_Flood_Zone_Ind: '?',
      Brush_Hazard_Ind: '?',
      Addl_Res_Ind: '?',
      Principle_Unit_Ind: '?',
      Fire_Extinguisher_Ind: '?',
      Central_Heat_Ind: '?',
      Wood_Stove_Ind: '?',
      Wood_Insert_Ind: '?',
      Recent_Loss_Ind: '?',
      Ins_Transferred_Ind: '?',
      Ins_Declined_Ind: '?',
      Other_Struct_Ind: '?',
      Comm_Exposure_Ind: '?',
      Section_II_Ind: '?',
      Resident_Employees_Ind: '?',
      Other_Ins_With_Carrier_Ind: '?',
      Animals_Exotic_Pets_Ind: '?',
      Tidal_Water_Ind: '?',
      Owns_RV_Ind: '?',
      Retrofitted_Earthquake_Ind: '?',
      Convicted_Arson_Ind: '?',
      Premises_Manager_Ind: '?',
      Security_Attendant_Ind: '?',
      Entrance_Locked_Ind: '?',
      Building_Code_Violations_Ind: '?',
      For_Sale_Ind: '?',
      Trampoline_Ind: '?',
      Lead_Paint_Hazard_Ind: '?',
      Foreclosure_Ind: '?',
      Backruptcy_Ind: '?',
      Structure_Converted_Ind: '?',
      Other_Ins_Oil_Tank_Ind: '?',
      Storm_Shutters_Ind: '?',
      Visible_To_Neighbors_Ind: '?',
      City_Limits_Ind: '?',
      Protected_Suburb_Ind: '?',
      NonSmoker_Ind: '?',
      Lightning_Protect_Ind: '?',
      Manned_Security_Ind: '?',
      Off_Premises_Theft_Excl_Ind: '?',
      Bankrupt_Foreclose_Repos_Ind: '?',
      Dog_On_Premises_Ind: '?',
      Tucked_Under_Parking_Ind: '?'
    },
    CDHM_Inspection: {
      Photo_Ind: '?'
    },
    CDHM_State: {
      Wind_Plan_Ind: '?',
      Rural_Protect_Ind: '?',
      Continuous_Renewal_Ind: '?',
      Inspection_Credit_Ind: '?',
      Single_Entry_Apt_Ind: '?',
      Class_H_Warranty_Ind: '?',
      Fringe_Rate_Ind: '?'
    },
    CDHM_Replace_Cost: {
      Slab_Ind: '?',
      Attic_Ind: '?',
      Fireplace_Ind: '?',
      Basement_Rec_Ind: '?',
      Balcony_Deck_Ind: '?',
      Walkout_Ind: '?'
    },
    CDHM_Mobile: {
      New_Ind: '?',
      Park_Ind: '?',
      Perm_Electric_Connect_Ind: '?',
      Perm_Water_Connect_Ind: '?',
      Perm_Sewer_Connect_Ind: '?',
      Perm_Phone_Connect_Ind: '?',
      Doublewide_Ind: '?',
      Skirted_Ind: '?',
      Approved_Ind: '?',
      Resident_Manager_Ind: '?',
      Limited_Access_Ind: '?',
      Paved_Ind: '?',
      Subdivisions_Ind: '?',
      Visible_From_Road_Ind: '?'
    }
  },
  CDHM_Mobile_Home: {
    Ins_Declined_Ind: '?',
    Bankrupt_Foreclose_Repos_Ind: '?',
    Tidal_Water_Ind: '?',
    Brush_Hazard_Ind: '?',
    Addl_Res_Ind: '?',
    Business_Premises_Ind: '?',
    Animals_Exotic_Pets_Ind: '?',
    Owns_RV_Ind: '?',
    Other_Ins_With_Carrier_Ind: '?',
    Convicted_Arson_Ind: '?',
    Doublewide_Ind: '?',
    New_Ind: '?',
    Skirted_Ind: '?',
    Park_Ind: '?',
    Approved_Ind: '?',
    Resident_Manager_Ind: '?',
    Limited_Access_Ind: '?',
    Paved_Ind: '?',
    Subdivisions_Ind: '?',
    Visible_From_Road_Ind: '?',
    Perm_Electric_Connect_Ind: '?',
    Perm_Water_Connect_Ind: '?',
    Perm_Sewer_Connect_Ind: '?',
    Perm_Phone_Connect_Ind: '?',
    Photo_Ind: '?'
  },
  CDHM_CPL: {
    Photo_Ind: '?',
    Slab_Ind: '?',
    Attic_Ind: '?',
    Fireplace_Ind: '?',
    Basement_Rec_Ind: '?',
    Balcony_Deck_Ind: '?',
    Walkout_Ind: '?',
    Protection_Class_Ind: '?',
    Business_Premises_Ind: '?',
    Under_Constr_Ind: '?',
    Day_Occupied_Ind: '?',
    Brush_Hazard_Ind: '?',
    Addl_Res_Ind: '?',
    Fire_Extinguisher_Ind: '?',
    Recent_Loss_Ind: '?',
    Ins_Transferred_Ind: '?',
    Ins_Declined_Ind: '?',
    Other_Struct_Ind: '?',
    Comm_Exposure_Ind: '?',
    Section_II_Ind: '?',
    Resident_Employees_Ind: '?',
    Other_Ins_With_Carrier_Ind: '?',
    Animals_Exotic_Pets_Ind: '?',
    Tidal_Water_Ind: '?',
    Owns_RV_Ind: '?',
    Retrofitted_Earthquake_Ind: '?',
    Convicted_Arson_Ind: '?',
    Premises_Manager_Ind: '?',
    Security_Attendant_Ind: '?',
    Entrance_Locked_Ind: '?',
    Building_Code_Violations_Ind: '?',
    For_Sale_Ind: '?',
    Trampoline_Ind: '?',
    Lead_Paint_Hazard_Ind: '?',
    Foreclosure_Ind: '?',
    Structure_Converted_Ind: '?',
    Backruptcy_Ind: '?',
    Other_Ins_Oil_Tank_Ind: '?',
    Storm_Shutters_Ind: '?',
    Visible_To_Neighbors_Ind: '?',
    NonSmoker_Ind: '?',
    Lightning_Protect_Ind: '?',
    Manned_Security_Ind: '?',
    Off_Premises_Theft_Excl_Ind: '?'
  }
};
